import { ProcedureChecklistType } from "@/model/Procedure/ProcedureChecklistType";
import { Button } from "@mui/material";
import StatusUncheckedIcon from "@/assets/svg/interactions/icon-status-unchecked.svg?react";
import SensorsIcon from "@mui/icons-material/Sensors";
import { CheckpointType } from "@/components/Procedures/Types/ManualChecklistTypes";



export const getStepType = (type: CheckpointType) => {
	switch (type) {
		case CheckpointType.Checkpoint:
			return (
				<Button
					variant="contained"
					color="error"
					type="button"
					sx={{
						padding: 1,
						minWidth: "40px",
						margin: 1,
					}}
				>
					<StatusUncheckedIcon className="svg-icon svg-icon-white svg-icon--status" />
				</Button>
			);
		case CheckpointType.SATOSLive:
			return (
				<Button disabled type="button" variant="text">
					<SensorsIcon />
				</Button>
			);
		case CheckpointType.Info:
			return null;
		case CheckpointType.ManualMeasurement:
			return (
				<Button
					variant="contained"
					color="error"
					type="button"
					disabled
					sx={{
						padding: 1,
						minWidth: "40px",
						margin: 1,
					}}
				>
					<StatusUncheckedIcon className="svg-icon svg-icon-white svg-icon--status" />
				</Button>
			);
		default:
			return null;
	}
};